module.exports = __webpack_public_path__ + "media/images/screens-58fced9cdb25eb56fd040dc4acd1b6c3.png";